// Internal Module Imports
import { BASE_URL_BIDDING_SERVICE } from '../../../constants';
import { HttpClient } from '../../../utils/httpClient';

const PATH = {
    getAll: `/${BASE_URL_BIDDING_SERVICE}/root/bidding-credentials`,
};

const GetAll = (start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getAll}`).then(callback).catch(error).finally(next);
};

export const RootBidCredentialsService = {
    GetAll,
};
